import { useDispatch } from 'react-redux';
import { StoreActionTypes } from 'store/reducer';

const useStoreActions: () => (action: StoreActionTypes) => void = useDispatch;

export default useStoreActions;
